<!--
목적 : 교육 문제풀이 SET 컴포넌트
-->
<template>
  <div class="fix-height">
    <q-field
      ref="customEquip"
      class="customEquip"
      :dense="dense"
      stack-label
      filled
      color="orange-custom"
      :label="convertLabel"
      :disable="disabled||!editable"
      :rules="!required ? null : [val => !!val || '']"
      v-model="valueText"
      >
      <template v-slot:label v-if="label">
        <div class="row items-center all-pointer-events">
          <b>
            <i v-if="!required" class="pe-7s-note labelfrontIcon searchAreaLabelIcon"></i>
            <font class="formLabelTitle">{{convertLabel}}</font>
            <i v-if="required" class="material-icons labelfrontIcon text-requiredColor">check</i>
          </b>
        </div>
      </template>
      <template v-slot:control>
        {{valueText}}
      </template>

      <template v-slot:append>
        <q-icon v-if="!disabled&&editable" name="search" @click="search" class="cursor-pointer"></q-icon>
        <q-icon v-if="!disabled&&editable" name="close" @click="reset" class="cursor-pointer"></q-icon>
      </template>
    </q-field>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import mixinCommon from './js/mixin-common'
export default {
  name: 'c-edu-quiz',
  mixins: [mixinCommon],
  props: {
    name: {
      type: String,
      default: 'field',
    },
    // TODO : 부모의 v-model의 값을 받아오는 속성
    value: { // 사용자의 id를 받아 처리
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    // 쓰기 권한 여부
    editable: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'edu',
    },
    placeholder: {
      type: String,
      default: '',
    },
    // 필수 입력 여부
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      vValue: null,
      valueText: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '60%',
        param: {},
        closeCallback: null,
      },
      quizList: null,
    };
  },
  computed: {
  },
  watch: {
    // todo : 부모의 v-model 변경을 감시
    value: {
      handler: function () {
        if (this.value !== null) {
          this.vValue = this.value;
          this.getQuizList();
          // this.setValueText();
        } else {
          this.$emit('input', null);
          this.valueText = '';
        }
      },
      deep: true,
    },
  },
  /* Vue lifecycle: created, mounted, destroyed, etc */
  beforeMount() {
    this.vValue = this.value;
    this.listUrl = selectConfig.sop.edu.quiz.mst.list.url;
    this.setValueText();
  },
  mounted() {
    if (!this.disabled) {
      this.$refs['customEquip'].$el.getElementsByClassName('q-field__native')[0].addEventListener('click', this.search);
    }
  },
  beforeDestroy() {
    if (!this.disabled) {
      this.$refs['customEquip'].$el.getElementsByClassName('q-field__native')[0].removeEventListener('click', this.search);
    }
  },
  /* methods */
  methods: {
    getQuizList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        useFlag: 'Y',
      }
      this.$http.request((_result) => {
        this.quizList = _result.data;
        this.setValueText();
      },);
    },
    /**
     * v-model로 받은 값을 통해 사용자 정보 조회
     *
     * type에 따라 valueText에 표시되는 값 변경
     */
    setValueText() {
      if (this.vValue) {
        if (!this.quizList) {
          this.getQuizList();
        } else 
        if (this.quizList.length === 0) {
          this.$emit('input', null);
          this.valueText = '';
        } else {
          let equip = this.$_.find(this.quizList, { eduQuestionMstId: this.vValue });
          if (equip) {
            this.valueText = equip.eduQuestionMstName
          } else {
            this.$emit('input', null);
            this.valueText = '';
          }
        }
      } else {
        this.valueText = '';
      }
    },
    search() {
      this.popupOptions.title = 'LBL0000711'; // 교육 문제풀이 SET 검색
      this.popupOptions.param = {
        type: 'single',
        useFlag: 'Y',
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/edu/quiz/quizPop.vue'}`);
      this.popupOptions.width = '60%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.quizList = data;
        if (this.type === 'edu') {
          this.valueText = data[0].eduQuestionMstName;
        }
        this.$emit('input', data[0].eduQuestionMstId);
        this.$emit('dataChange', data[0]);
      }
    },
    reset() {
      this.valueText = '';
      this.$emit('input', null);
      this.$emit('dataChange', null);
    },
  },
};
</script>
<style lang="sass">
.customEquip
  padding-bottom: 20px !important
  .q-field__native.row
    padding-left: 3px
    font-size: 0.95em
    padding-top: 4px !important
  .q-field__native
    padding-bottom: 6px !important
    cursor: pointer
  .q-field__label
    margin-left: 5px
  .material-icons
    font-size: 0.8rem
  .dateCloseIcon
    font-size: 0.8rem !important
    display: none
.customEquip:hover
  .dateCloseIcon
    display: block
.customEquip.q-field--dense .q-field__control, .customEquip.q-field--dense .q-field__marginal
  height: 33px !important
  min-height: 33px !important
.customEquip.q-field--filled .q-field__control
  border: 1px solid rgba(0,0,0,0.15) !important
  padding: 0px 8px 0px 2px
</style>